import { Box, Chip } from '@mui/material';
import { TableV2Column } from 'components/Table/TableV2';
import { RouterLink } from 'common/ui/RouterLink';
import { AnchorText } from 'components/Text';
import { Paths } from 'services/navigation/paths';
import { CandidateBatchStatus } from 'generated-graphql/types';
import { ChooseAnalysisItem } from 'modules/campaign-creation/types/ChooseAnalysisItem';
import { getAnalysisTitle } from 'utils/getAnalysisTitle';

const getStatusDisplay = (status: CandidateBatchStatus | undefined | null) => {
  if (status === CandidateBatchStatus.Live) {
    return <Chip label="Live" color="success" />;
  }
  return <Chip label="Draft" color="info" sx={{ color: 'black' }} />;
};

export const getChooseAnalysisTableColumns =
  (): TableV2Column<ChooseAnalysisItem>[] => [
    {
      name: 'Analysis name',
      cell: (row) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <RouterLink
            to={`${Paths.CANDIDATES_RANKING}/${row.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <AnchorText>{getAnalysisTitle(row, row.id)}</AnchorText>
          </RouterLink>
        </Box>
      ),
      minWidth: '150px'
    },
    {
      name: 'Location',
      selector: (row) => row.jobDescriptionParsed?.location || '-'
    },
    {
      name: 'Employer',
      selector: (row) => row.jobDescriptionParsed?.employerName || '-'
    },
    {
      name: 'Job ID',
      selector: (row) => row.atsJobId || '-'
    },
    {
      name: 'Status',
      cell: (row) => getStatusDisplay(row.status)
    },
    {
      name: 'Applied',
      selector: (row) => row.candidatesCount || '-',
      width: '110px'
    },
    {
      name: 'Owner',
      cell: (row) => (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <span>{row.user?.name || '-'}</span>
        </Box>
      ),
      width: '150px'
    }
  ];
